import type { ReactNode } from "react";

export type DocumentSplitViewProps = {
  arenaId: number;
  documentId: string;
  children: ReactNode;
};

// PDF pane removed: documentViewerUrl has no backend resolver yet (DDQ-319).
export const DocumentSplitView = ({ children }: DocumentSplitViewProps) => {
  return <div data-testid="ddq-split-view">{children}</div>;
};
